import { loadStripe } from "@stripe/stripe-js";
import { StripeEnvironment } from "../../../constants/environment";

export async function redirectToCheckout(sessionId: string): Promise<void> {
  try {
    const stripe = await loadStripe(StripeEnvironment.STRIPE_PUBLISHABLE_KEY);

    if (!stripe) {
      throw new Error("Failed to load Stripe");
    }

    const { error } = await stripe.redirectToCheckout({ sessionId });

    if (error) {
      console.error("Stripe redirect error:", error);
      throw error;
    }
  } catch (error) {
    console.error("Error redirecting to Stripe checkout:", error);
    throw error;
  }
}
